<div class="row">
  <div class="medium-12 column">
    <div style="font-size: 18px;color: #475467">Zapier Integration</div>
    <hr style="margin-left: 0"/>
    <button class="button small" style="background: #1570EF !important;border-radius: 20px !important;" (click)="openConnectionUrl()">Connect</button>
  </div>
</div>
